import _ from 'lodash'
const getters = {}

getters.widgetNotifications = function(state) {
  const ELEMENTS_TO_GET = 25
  return state.notifications.slice(0, ELEMENTS_TO_GET)
}

getters.notifications = function(state) {
  return _.orderBy(state.notifications, 'createdAt', 'desc')
}

getters.hasUnReadNotifications = function(state) {
  const unReadNotifications = state.notifications?.find(notification => {
    return notification.read === false
  })

  return !!unReadNotifications
}

export default getters
